import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, ToastProvider, TooltipProvider } from '@uatp/ui';
import { RouterProvider } from 'react-router';
import { setUnauthorizedHandler } from './api/client';
import { ME_KEY } from './auth/auth';
import { queryClient } from './lib/query';
import { router } from './routes';

// A 401 from any call (expired or revoked session) sends the admin back to sign-in, keeping their place.
setUnauthorizedHandler(() => {
  // Before the first successful /auth/me the AuthGate redirects by itself (no "session ended" message).
  if (/^\/(login|set-password)/.test(window.location.pathname) || !queryClient.getQueryData(ME_KEY)) return;
  queryClient.clear();
  const returnTo = `${window.location.pathname}${window.location.search}`;
  void router.navigate(`/login?returnTo=${encodeURIComponent(returnTo)}&message=${encodeURIComponent('Your session has ended. Please sign in again.')}`);
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system" storageKey="uatp.admin.theme" lang="en">
        <TooltipProvider delayDuration={400}>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
